//TODO: this is a temporary solution, we should use a proper error handling library
//TODO: implement a styled notification component when we have the design
export function handleError(e: any) {
  alert(e)
}
